import { CreateMoItemByBBPRequest } from './create-moItem-request';

export class CreateDoByBBPRequest {
  facility: string | null;  //  y
  storer: string | null;  //  y
  plant: string | null ; //  y
  deliveryType: string | null;  //  y
  consigneeKey: string | null;  //  y
  consigneeCompany: string | null;  //  y
  consigneeAddress1: string | null; //  y // LaaS ConsigneeAddress2
  consigneeAddress2: string | null; // LaaS ConsigneeAddress3
  specLocType: string | null;
  priority: string | null;
  notes: string | null;
  isBonded: string | null;
  moItemList: CreateMoItemByBBPRequest[] | [];
  checkInventoryFlag: boolean | undefined;
  urgentType: string | null;
  urgentReason: string | null;
  ctn: string | null;
  asnNo: string | null;
  etd: Date | null;
  eta: Date | null;
  calloffReason: string | null;

  constructor() {
    this.facility = null;
    this.storer = null;
    this.plant = null;
    this.deliveryType = null;
    this.consigneeKey = null;
    this.consigneeCompany = null;
    this.consigneeAddress1 = null;
    this.consigneeAddress2 = null;
    this.specLocType = null;
    this.priority = null;
    this.notes = null;
    this.isBonded = null;
    this.moItemList = [];
    this.checkInventoryFlag = false;
    this.urgentType = null;
    this.urgentReason = null;
    this.ctn = null;
    this.asnNo = null;
    this.etd = null;
    this.eta = null;
    this.calloffReason = null;
  }
}
